import React, { useState } from "react";
import {
  FormApi,
  CrudForm,
  Select,
  RichText,
  useParentChildrenNavigation,
  CrudTabs,
  CrudRoute,
  SimpleDialog,
} from "elentari";
import { treinoApi } from "../../services/Api";
import { useTreinoObjetivos } from "./treinoHooks";
import Grid from "@material-ui/core/Grid";
import { TextField } from "final-form-material-ui";
import { Field } from "react-final-form";
import SerieList from "./SerieList";
import SerieForm from "./SerieForm";

function TreinoForm(props) {
  const treinoObjetivos = useTreinoObjetivos();
  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
    treinoObjetivoId: values.treinoObjetivoId ? undefined : "Obrigatório",
    tipo: values.tipo ? undefined : "Obrigatório",
  });
  const treinoTipos = [
    { value: "Choque", label: "Choque" },
    { value: "Condicionante", label: "Condicionante" },
    { value: "Regenerativo", label: "Regenerativo" },
  ];

  const [copiaTreinoMessage, setCopiaTreinoMessage] = useState();

  const customActions = [
    {
      label: "Duplicar",
      onClick: async () => {
        const response = await treinoApi.duplicate(props.match.params.id);
        if (response.ok) {
          setCopiaTreinoMessage(
            "Cópia do treino realizada com sucesso! Este é o novo treino"
          );
          return props.history.replace(`/treinos/${response.data.id}`);
        }
        setCopiaTreinoMessage("Erro ao fazer cópia do treino");
      },
    },
  ];

  const {
    match: { params },
  } = props;
  const showCustomActions = () => params.id !== "new";

  return (
    <FormApi api={treinoApi} {...props}>
      {({ handleSubmit, getItem }) => (
        <CrudForm
          validate={validate}
          customActions={showCustomActions() ? customActions : []}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={16}>
            <Grid item sm>
              <Field
                fullWidth
                autoFocus
                component={TextField}
                label="Nome"
                name="nome"
              />
            </Grid>
            <Grid item sm>
              <Field
                fullWidth
                component={Select}
                options={treinoTipos}
                label="Tipo"
                name="tipo"
              />
            </Grid>
            <Grid item xs>
              <Field
                fullWidth
                component={Select}
                options={treinoObjetivos}
                label="Objetivo"
                name="treinoObjetivoId"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                component={RichText}
                label="Observações"
                name="observacoes"
              />
            </Grid>
          </Grid>
          <SimpleDialog
            title="Cópia do Treino"
            message={copiaTreinoMessage}
            open={!!copiaTreinoMessage}
            handleClose={() => setCopiaTreinoMessage("")}
          />
        </CrudForm>
      )}
    </FormApi>
  );
}

export default function TreinoTabs(props) {
  const { current, navigate, toEditChild, toNewChild } =
    useParentChildrenNavigation(props, {
      mainPath: "treinos",
      availableTabs: ["series"],
    });
  return (
    <CrudTabs
      {...props}
      mainPath="treinos"
      current={current}
      tabs={[
        { value: "", label: "Treino" },
        { value: "series", label: "Séries" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <TreinoForm {...props} />} />
        <CrudRoute
          name="series"
          render={(props) => (
            <SerieList
              onClickNew={toNewChild}
              onClickEdit={toEditChild}
              {...props}
            />
          )}
        />

        <CrudRoute
          isForm
          name="series"
          render={(props) => <SerieForm {...props} />}
        />
      </div>
    </CrudTabs>
  );
}
